module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-6.a784fb1f.png";